import { Fragment } from "react";
import { useSelector } from "react-redux";
import { ReportingWidget } from "./reportingwidget";
import { formatNumber, getThemeColors, isEmptyObject, shortenNumber } from "../../lib/utils";
import { WIDGET_NUMERIC_CARD, thousandSeparators, isErrorColor, getVariationDirection } from "./utils";


const CardNumericWidgetContent = props => {
    const {
        id, 
        fontSize, fontIsBold, fontIsUnderline, fontIsItalic, fontColor, 
        isVariation, isVariationReverse,
        decimalPlaces, thousandSeparator, trailingValue, isPercent, trimLargeValue, 
        isError, errorOperator, errorThreshold, beepIfError,
        data, schema,
        ...other } = props;

    const currentTheme = useSelector(state => state.currentTheme);
    
    const resolvedThousandSeparator = thousandSeparators.find(e => e.id == thousandSeparator).title;

    let _data = data;
    //console.log("11", data, _data, isEmptyObject(data), isPercent)

    if(data == null || isEmptyObject(data))
        _data = null;

    //resolving color except variation color
    let resolvedColor = undefined;
    if (isError === true)
       resolvedColor = currentTheme.error;
    else
       resolvedColor = getThemeColors(currentTheme).find(e => e.id == fontColor).color;
      
       
    let resolvedData = (_data == null) ? "Null" : (trimLargeValue ? shortenNumber(_data, decimalPlaces) : formatNumber(_data, decimalPlaces, resolvedThousandSeparator));
    
    if(_data != null && isPercent)
        resolvedData += "%";

    if (_data != null && trailingValue)
        resolvedData += trailingValue;            
    
    //variation
    let variationResolvedColor = undefined;
    let variationIcon = undefined;

    if (isVariation && _data != null)
    {
        const variationDirection = getVariationDirection(_data, isVariationReverse);
        variationResolvedColor = variationDirection == 1 ? currentTheme.success : currentTheme.error;

        variationIcon = parseFloat(_data) > 0 ? "k-i-sort-asc-sm" : "k-i-sort-desc";
    }

 
    return (
        <Fragment>
           <div className={`card-numeric-content card-numeric-content-${id}`} 
                style={{
                    fontSize: fontSize, color: resolvedColor, textDecoration: fontIsUnderline ? "underline" : "none", 
                    fontStyle: fontIsItalic ? "italic" : "normal", fontWeight: fontIsBold ? 700 : 500,
                }}>           
                <Fragment>
                    <div style={{}}>{resolvedData}</div>
                    {
                        _data != null && isVariation && 
                        <div style={{
                            color: variationResolvedColor, marginLeft: 10,
                            fontSize: fontSize, fontWeight: fontIsBold ? 700 : 500
                        }} className={`k-icon ${variationIcon}`}></div>
                    }                    
                </Fragment>            
            </div>
            <style>
                {
                    `
                        .card-numeric-content
                        {
                            text-align: center;       
                            flex: 1;
                            display: flex;
                            justify-content: center;
                            align-items: center;                   
                        }
                    `
                }
            </style>
        </Fragment>
    );
};


export const CardNumericWidget = props => {
    const {                
        id,
        mode, 
        loaded, loading, errorText, canceled,
        backgroundColor, title, titleFontSize, titleFontIsBold, titleFontIsUnderline, titleFontIsItalic, titleFontColor,
        getContextMenu, onMenuItemClick,
        onWidgetSelect, onWidgetUnSelect, onDoubleClick, ...other} = props;

   
    //error value - since we want the title to be in error color when error condition is true, let's compute error color here
    const data = props.data;
    const errorOperator = props.errorOperator;
    const errorThreshold = props.errorThreshold;

    let resolvedTitleFontColor = titleFontColor;
    let isError = false;
    if(data != null && !isEmptyObject(data))
    {
     if (isErrorColor(data, errorOperator, errorThreshold) === true)
        {
            isError = true;
            resolvedTitleFontColor = 3;
        }
    }

    const isPercent = props.schema[0].IsPercent;    
    return (
        <Fragment>
             <ReportingWidget id={id} widgetTypeId={WIDGET_NUMERIC_CARD} dataSourceValueType={2} 
                mode={mode} loaded={loaded} loading={loading} errorText={errorText} canceled={canceled}
                backgroundColor={backgroundColor} 
                title={title} titleFontSize={titleFontSize} titleFontIsBold={titleFontIsBold} 
                titleFontIsUnderline={titleFontIsUnderline} titleFontIsItalic={titleFontIsItalic} titleFontColor={resolvedTitleFontColor}
                getContextMenu={getContextMenu} onMenuItemClick={onMenuItemClick} onWidgetSelect={onWidgetSelect} onWidgetUnSelect={onWidgetUnSelect} 
                onDoubleClick={onDoubleClick}>
                    <CardNumericWidgetContent {...props} isPercent={isPercent} isError={isError} />
            </ReportingWidget>
            <style>
                {
                    `
                        
                    `
                }
            </style>
        </Fragment>
    );
};